// validate channelId
const channelId = serverProfile.channelId;
if (channelId) {
  sessionStorage.setItem('channelId', channelId);
}

(function strictHttps(l) {
  // client-side redirect http to https
  if (serverProfile.environment !== 'dev' && !/https:/i.test(l.protocol)) {
    l.replace(l.href.replace(/^http:/, 'https:'));
  }
})(window.location);

(function maintenanceCheckin() {
  if (new URL(window.location.href).searchParams.get('angel') === null) {
    fetch(`${serverProfile.maintenanceUrl}?_=${Date.now()}`)
      .then((res) => {
        return res.ok ? res.json() : Promise.reject();
      })
      .then((res) => {
        const data = res && res.creator;
        if (
          data &&
          data.lock &&
          data.lockTimestamp &&
          Date.now() >= data.lockTimestamp
        ) {
          window.location = `/503?redirectUrl=${encodeURIComponent(
            window.location.href
          )}`;
        }
      });
  }
})();

window.intercomSettings = {
  hide_default_launcher: true,
  alignment: 'right',
  horizontal_padding: 20,
  vertical_padding: 80,
};

function checkContext() {
  return new Promise(function (resolve) {
    const inIframe = window.self !== window.top;
    const authenticationManager =
      new URL(window.location.href).searchParams.get(
        'authentication-manager'
      ) || sessionStorage.getItem('authentication-manager');

    const onSelfWindowMessage = function (e) {
      if (typeof e.data === 'object' && e.data.cmd === 'studioOptions') {
        if (e.data.JWT) {
          sessionStorage.setItem('Authorization', 'Bearer ' + e.data.JWT);
        }
        if (e.data.kalturaProperties) {
          sessionStorage.setItem(
            'kalturaProperties',
            JSON.stringify(e.data.kalturaProperties)
          );
        }
        if (e.data.isReEditing) {
          sessionStorage.setItem('reEditEmbedded', true);
        } else {
          sessionStorage.removeItem('reEditEmbedded');
        }

        window.removeEventListener('message', onSelfWindowMessage);
        resolve();
      }
    };

    if (inIframe && window.parent) {
      window.addEventListener('message', onSelfWindowMessage);
      window.parent.postMessage('studioLoaded', '*');
    } else if (
      authenticationManager === 'self-serve-admin' &&
      window.opener &&
      !sessionStorage.getItem('Authorization')
    ) {
      // studio opened from admin, interested only in JWT
      sessionStorage.setItem('authentication-manager', authenticationManager);
      window.addEventListener('message', onSelfWindowMessage);
      // '*' masked cause there is no secret, and we don't know what exact domain need this
      window.opener.postMessage('studioLoaded', '*');
    } else {
      resolve();
    }
  });
}

function $_fetch(url, sendOrgHeader = true) {
  const headers = {};
  const channelId = sessionStorage.getItem('channelId');
  const organizationId = localStorage.getItem('selectedOrganizationId');
  const auth = sessionStorage.getItem('Authorization');
  const baseUrl = serverProfile.apiUrl;
  const now = Date.now();

  if (channelId) {
    headers['Channel-ID'] = channelId;
  }

  if (auth) {
    headers['Authorization'] = auth;
  }

  if (sendOrgHeader && organizationId) {
    headers['organization-Id'] = organizationId;
  }

  const fullUrl = `${baseUrl}/api/v1/${url}?_=${now}`;

  return fetch(fullUrl, {
    credentials: 'include',
    headers,
  });
}

async function login() {
  let res;
  let globalContext;
  let organizations;
  let organizationId;
  try {
    res = await $_fetch('users/me/organizations', false);
  } catch (err) {
    console.error(err);
    throw new Error('Error fetching organization list');
  }
  if (res.status !== 200) {
    console.info('User not logged in. Redirecting...');
    let url;
    const queryString = {};
    if (channelId) {
      queryString.channelId = channelId;
      url = '/login';
    } else {
      url = serverProfile.loginUrl;
    }
    queryString.redirectUrl = encodeURIComponent(window.location.href);
    window.location =
      url +
      '?' +
      Object.keys(queryString)
        .reduce((arr, key) => [...arr, key + '=' + queryString[key]], [])
        .join('&');
    return;
  }

  try {
    const organizationsJson = await res.json();
    organizations = organizationsJson.organizations;
  } catch (err) {
    throw new Error('Error parsing json when fetching organizations');
  }

  const organizationIds = organizations.map((o) => o.organizationId);
  organizationId = +localStorage.getItem('selectedOrganizationId');
  if (!organizationId || !organizationIds.includes(organizationId)) {
    organizationId = organizations[0].organizationId;
    localStorage.setItem('selectedOrganizationId', organizationId);
  }
  res = await $_fetch('settings/global');

  try {
    globalContext = await res.json();
  } catch (err) {
    throw new Error('Error parsing json when fetching global context');
  }

  window.tk = globalContext;
  window.tk.context.user.organizations = organizations;
  window.tk.context.user.selectedOrganizationId = organizationId;

  if (channelId) {
    window.tk.channelId = channelId;
  }
  window.tk.context._broadcastChannelName =
    'wochit-broadcast-channel-v1-' + serverProfile.environment;
  return window.tk;
}

// const wait = (sec) => new Promise((resolve) => setTimeout(resolve, sec * 1e3))

window.whenContextLoaded = new Promise((resolve) => {
  checkContext()
    .then(login)
    .then(() => {
      resolve();
    });
});
